import { StClubLogo, StClubName, StContainer } from './MatchClub.styled'

import type { StoryblokImage } from 'types'

type MatchClubProps = {
  className?: string
  name: string
  logo?: StoryblokImage
  variant?: 'light' | 'dark'
}

export const MatchClub = ({
  className,
  logo,
  name,
  variant = 'dark',
}: MatchClubProps) => {
  return (
    <StContainer className={className}>
      {logo && <StClubLogo image={logo} width={150} height={52} />}
      <StClubName variant={variant}>{name}</StClubName>
    </StContainer>
  )
}
